import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "price-search-card" }
const _hoisted_2 = { class: "notice__block" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceSearchCard',
  props: {
  options: {
    type: Object,
    required: true,
  },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_BaseCalculator = _resolveComponent("BaseCalculator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "price-search-card__top" }, [
        _createElementVNode("div", { class: "price-search-card__title" }, " Ihr persönliches Produkt ")
      ], -1)),
      _createVNode(_component_BaseCalculator, {
        postcode: __props.options.postcode,
        "preselected-options": __props.options,
        type: "component"
      }, null, 8, ["postcode", "preselected-options"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("p", null, [
          _createElementVNode("b", null, "*"),
          _createTextVNode(" Strom: Die Preisfixierung bezieht sich auf den Arbeitspreis netto ohne Steuern, Abgaben und Umlagen sowie auf den Grundpreis netto ohne Messstellenbetrieb. Dynamische Tarife mit Energiepreisfixierung im ersten Liefermonat. "),
          _createElementVNode("br"),
          _createTextVNode(" Gas: Die Preisfixierung bezieht sich auf den Arbeitspreis netto ohne Steuern, Abgaben und Umlagen. ")
        ], -1)),
        (__props.options.business)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Alle weiteren Preise sind Nettopreise exkl. der gesetzlichen MwSt. Sie werden auf zwei Nachkommastellen gerundet dargestellt. "))
          : (_openBlock(), _createElementBlock("p", _hoisted_5, " Alle weiteren Preise sind Bruttopreise inkl. der gesetzlichen MwSt. Sie werden auf zwei Nachkommastellen gerundet dargestellt. ")),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, null, -1))
      ])
    ])
  ], 64))
}
}

})